import { FreeReducedMealAppChildIncome } from './free-reduced-meal-app-child-income.model';
import { FreeReducedMealAppChildProgram } from './free-reduced-meal-app-child-program.model';
import { FreeReducedMealAppPerson } from './free-reduced-meal-app-person.model';

export class FreeReducedMealAppChild extends FreeReducedMealAppPerson {

    StudentID: number;
    IsFosterChild: boolean;
    HasIncome: boolean;
    LunchStatus: string;
    GradeLevel: string;
    Income: FreeReducedMealAppChildIncome[] = [];
    Programs: FreeReducedMealAppChildProgram[] = [];

    constructor() {
        super();
    }
}